export default __webpack_public_path__ + "static/media/Pear@1x.1f424afc.png";